import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaCar, FaSearch, FaMapMarkerAlt, FaListAlt } from 'react-icons/fa';

const onlineColor = '#2ECC71';
const offlineColor = '#E74C3C';
const selectedBorderColor = '#3498DB';

export default function SumarioVeiculos() {
    const [summaryData, setSummaryData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedVehicleId, setSelectedVehicleId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSummaryData = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = localStorage.getItem("token"); // Recupera o token do localStorage
                const response = await axios.get('https://sis.itraker.com.br/api/associacaoapp', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const dados = response.data.dados || [];
                const veiculos = dados.map(item => ({
                    id: item.idProdutos,
                    marca: item.veiculo_produto?.split(' ')[0] || 'N/I',
                    modelo: item.veiculo_produto?.replace(item.veiculo_produto?.split(' ')[0], '').trim() || 'N/I',
                    placa: item.placa_produto,
                    latitude: parseFloat(item.lat),
                    longitude: parseFloat(item.long),
                    status: item.statusassociacao === 'ATIVO' ? 'online' : 'offline'
                }));

                const onlineCount = veiculos.filter(v => v.status === 'online').length;
                const offlineCount = veiculos.length - onlineCount;

                setSummaryData({ conectados: onlineCount, desconectados: offlineCount, veiculos });
            } catch (err) {
                setError('Erro ao carregar dados da API.');
            } finally {
                setLoading(false);
            }
        };

        fetchSummaryData();
    }, [navigate]);

    const handleVehicleClick = (vehicleId) => {
        setSelectedVehicleId(prev => (prev === vehicleId ? null : vehicleId));
    };

    const handleViewMap = (v) => {
        if (v.latitude && v.longitude) alert(`Mapa: ${v.placa} (${v.latitude}, ${v.longitude})`);
        else alert('Sem coordenadas.');
    };

    const handleExportToGoogleMaps = (v) => {
        if (v.latitude && v.longitude) window.open(`https://www.google.com/maps/search/?api=1&query=${v.latitude},${v.longitude}`, '_blank');
        else alert('Sem coordenadas.');
    };

    const handleViewHistory = (v) => {
        alert(`Histórico de ${v.placa}`);
    };

    if (loading) return <div style={styles.centeredMessage}>Carregando...</div>;
    if (error) return <div style={{ ...styles.centeredMessage, ...styles.errorMessage }}>{error}</div>;
    if (!summaryData) return <div style={styles.centeredMessage}>Sem dados.</div>;

    const { conectados, desconectados, veiculos } = summaryData;
    const total = conectados + desconectados;
    const percentOnline = total > 0 ? (conectados / total) * 100 : 0;
    const sorted = [...veiculos].sort((a, b) => a.status === 'online' ? -1 : 1);

    return (
        <div style={styles.container}>
            <div style={styles.summaryCard}>
                <h2 style={styles.cardTitle}>COMUNICAÇÃO DOS VEÍCULOS</h2>
                <div style={styles.communicationBody}>
                    <div style={styles.chartPlaceholder}>
                        <div style={{
                            ...styles.donutPlaceholder,
                            background: `conic-gradient(${onlineColor} 0% ${percentOnline}%, ${offlineColor} ${percentOnline}% 100%)`
                        }}>
                            <div style={styles.donutHole}>
                                <span style={styles.donutTotalText}>{total}</span>
                            </div>
                        </div>
                    </div>
                    <div style={styles.communicationText}>
                        <p style={styles.communicationLine}>
                            <span style={{ ...styles.count, color: onlineColor }}>{conectados}</span> Veículos ligados
                        </p>
                        <p style={styles.communicationLine}>
                            <span style={{ ...styles.count, color: offlineColor }}>{desconectados}</span> Veículos desligados
                        </p>
                    </div>
                </div>
            </div>

            <div style={styles.vehicleList}>
                {sorted.map((v) => (
                    <div key={v.id} style={styles.vehicleCardWrapper}>
                        <div
                            style={{
                                ...styles.vehicleCard,
                                border: selectedVehicleId === v.id
                                    ? `2px solid ${selectedBorderColor}`
                                    : `1px solid ${v.status === 'online' ? onlineColor : '#eee'}`
                            }}
                            onClick={() => handleVehicleClick(v.id)}
                        >
                            <p style={styles.vehicleMakeModel}>{v.marca?.toUpperCase()} - {v.modelo?.toUpperCase()}</p>
                            <FaCar style={{ ...styles.vehicleIcon, color: v.status === 'online' ? onlineColor : offlineColor }} />
                            <p style={styles.vehiclePlate}>{v.placa?.toUpperCase()}</p>
                        </div>
                        {selectedVehicleId === v.id && (
                            <div style={styles.actionButtonsContainer}>
                                <button onClick={() => handleViewMap(v)} style={styles.actionButton}><FaSearch /></button>
                                <button onClick={() => handleExportToGoogleMaps(v)} style={styles.actionButton}><FaMapMarkerAlt /></button>
                                <button onClick={() => handleViewHistory(v)} style={styles.actionButton}><FaListAlt /></button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: { padding: '20px', fontFamily: 'Arial, sans-serif' },
    centeredMessage: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '150px', fontSize: '16px', color: '#555', textAlign: 'center', padding: '20px' },
    errorMessage: { color: '#D32F2F', backgroundColor: '#FFEBEE', padding: '15px', borderRadius: '8px', border: '1px solid #FFCDD2', maxWidth: '600px', margin: '20px auto' },
    summaryCard: { backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '30px' },
    cardTitle: { fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px', textTransform: 'uppercase' },
    communicationBody: { display: 'flex', alignItems: 'center', gap: '30px', flexWrap: 'wrap' },
    chartPlaceholder: { flexShrink: 0, margin: '0 auto 15px auto' },
    donutPlaceholder: { width: '100px', height: '100px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' },
    donutHole: { width: '60px', height: '60px', backgroundColor: '#fff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' },
    donutTotalText: { fontSize: '18px', fontWeight: 'bold', color: '#555' },
    communicationText: { flexGrow: 1, textAlign: 'center' },
    communicationLine: { margin: '10px 0', fontSize: '15px', color: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    count: { fontSize: '28px', fontWeight: 'bold', marginRight: '10px', minWidth: '40px', textAlign: 'right' },
    vehicleList: { display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' },
    vehicleCardWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '1 1 160px', maxWidth: '200px' },
    vehicleCard: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '15px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        textAlign: 'center',
        width: '100%',
        cursor: 'pointer',
        transition: 'border 0.2s ease-in-out',
        marginBottom: '5px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '150px'
    },
    vehicleMakeModel: { fontSize: '11px', color: '#777', marginBottom: '10px', minHeight: '25px', wordWrap: 'break-word' },
    vehicleIcon: { fontSize: '36px', margin: '10px auto', transition: 'color 0.2s ease-in-out' },
    vehiclePlate: { fontSize: '14px', fontWeight: 'bold', color: '#444', marginTop: '10px', wordWrap: 'break-word' },
    actionButtonsContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', padding: '8px 0', width: '100%' },
    actionButton: {
        backgroundColor: '#A71C1C',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        width: '36px',
        height: '36px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.2s ease',
        boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
    }
};
